// extracted by mini-css-extract-plugin
export default {"filter":"people_filter_filter__0i6b-","Mui-focused":"people_filter_Mui-focused__FRDOg","label":"people_filter_label__ocslR"};